/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_ActionsInputs */

const cs_ui_more_actions = /** @type {(inputs: Ui_More_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další akce`)
};

const en_ui_more_actions = /** @type {(inputs: Ui_More_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More actions`)
};

/**
* | output |
* | --- |
* | "More actions" |
*
* @param {Ui_More_ActionsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ui_more_actions = /** @type {((inputs?: Ui_More_ActionsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_ActionsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_actions(inputs)
	return cs_ui_more_actions(inputs)
});